module.exports = __webpack_public_path__ + "assets/bc4e7f6290d62136bb4679136571fa65.svg";